<template>
	<core-loading-button
		v-bind="$attrs"
		v-on="$listeners"
		:color="disabled ? 'outline' : $get('color', 'green')"
		:loading="saving"
		:disabled="isDisabled"
		buttonType="submit"
	>
		<template v-if="finished && !hasFailed">Saved!</template>
		<template v-else-if="finished && hasFailed">Error!</template>
		<slot v-else>Save Changes</slot>
	</core-loading-button>
</template>

<script>
export default {
	inheritAttrs : false,
	props        : {
		disabled : Boolean,
		saving   : Boolean,
		failed   : Boolean,
		color    : String,
	},
	data () {
		return {
			finished  : false,
			timeout   : false,
			hasFailed : false,
		}
	},
	watch : {
		saving : function (isSaving) {
			if (!isSaving) {
				this.finished = true
				this.timeout = setTimeout(() => this.completeSave(), 1000)
			}
		},
		disabled : function (isDisabled) {
			if (isDisabled && !this.timeout) {
				this.completeSave()
			}
		},
		failed : function (failed) {
			this.hasFailed = failed
		},
	},
	computed : {
		isDisabled () {
			return this.disabled && !this.finished
		},
	},
	methods : {
		completeSave () {
			this.finished = false
			this.hasFailed = false
			if (this.timeout) {
				clearTimeout(this.timeout)
			}
		},
	},
}
</script>
